import React from 'react';
import { ThemeContainer } from 'appkit-react';
import useTheme from '@hooks/useTheme';

function AppkitThemeContainer({ children }) {
  const { theme } = useTheme();

  return <ThemeContainer theme={`theme-${theme}`}>{children}</ThemeContainer>;
}

export default AppkitThemeContainer;
